/**
 * Centralized API Endpoints Registry
 * Exact endpoint paths preserved as defined in backend services without adding or altering /v1.
 */

// 1. HelloTrade Backend Endpoints (REACT_APP_HELLOTRADE_API_BASE_URL)
export const HT_ENDPOINTS = {
  ADD_INFO: "/v1/addInfo",
  STAGE_MAPPING: "/v1/stageMapping",
  GET_CLIENT_DETAILS: "/v1/getClientDetails",
  UPDATE_BUSINESS_AGE: "/v1/updateBusinessAge",
  DOWNLOAD_CSV: "/v1/downloadCSV",
  CHECK_CONSENT: "/v1/check-consent",
  CREATE_CONSENT: "/v1/create-consent",
  UPDATE_LEAD_STAGE: "/v1/updateLeadStage",
  FETCH_CUSTOMER_DATA: "/v1/fetch-customer-data",
  PL_CHECK_STATUS: (glid) => `/v1/personal-loan/check-status/${glid}`,
  PL_CREATE_REFERRAL: "/v1/personal-loan/create-referral",
  PL_GENERATE_AUTH_TOKEN: "/v1/personal-loan/generate-auth-token",
  AA_INIT: "/v1/aa/consent/init",
  AA_FETCH: "/v1/aa/consent/fetch",
  AA_EVENT: "/v1/aa/consent/event",
   GET_LEAD_SUBSTAGE: "/v1/getLeadSubstage",
  GL_PINCODE_SERVICEABILITY: "v1/goldloan/pincode-serviceability",
  GL_SUBMIT_APPLICATION: "v1/goldloan/submit-application",
  GL_PROFILE: "v1/goldloan/profile",
  GL_CALC: "v1/goldloan/gold-price/calc",
  GL_STAGE_TO_PAGE_MAPPING: "v1/goldloan/stage-to-page-mapping",
  GL_FETCH_REQUIREMENT: "v1/goldloan/fetch-requirement",
  GL_MUTHOOT_REDIRECT: "v1/goldloan/muthoot-redirect-url",
};

// 2. Loans Backend Endpoints (REACT_APP_BACKEND_PATH)
export const LOANS_ENDPOINTS = {
  APPLY_CLICK_V4: "/v1/applyClickV4",
  USER_JOURNEY_DECISION: "/v1/userJourneyDecision",
  GET_JOURNEY_FLAGS: "/v1/getJourneyFlags",
  APPLY_CLICK_SHEET: "/v1/applyClickSheet",
  CAPTURE_CLICK: "/v1/captureClick",
  GET_DYNAMIC_LOAN_OFFER: "/v1/getDynamicLoanOffer",
  OFFER_CLICK: "/v1/offerClick",
  INITIATE_INDIFI_REDIRECT: "/v1/initiateIndifiRedirect",
  GET_OWNER_INFO: "/v1/getOwnerInfo",
  PL_CHECK_BUREAU: "v1/personal-loan/check-bureau",
  PL_AUTHENTICATE_DELIVERY: "v1/personal-loan/authenticate-delivery",
  GET_BUREAU_NS_JOURNEY: "/v1/getBureauNSJourney",
  WHATSAPP_OPTIN: "/v1/whatsapp/optin",
};

// 3. OTP MS Backend Endpoints (REACT_APP_HT_OTP_MS)
export const OTP_MS_ENDPOINTS = {
  CREATE_SESSION: "/create-session",
};

// 4. Finbox Proxy Endpoints (REACT_APP_HELLOTRADE_API_BASE_URL)
// These are served by go-api, which forwards them unchanged to the OTP-MS
// Node service. OTP-MS is reachable only over plain http, and the Banking
// page is served over https, so the browser cannot call it directly —
// mixed content. go-api is already https, so it acts as the front door.
// Paths match OTP-MS's own /api/v1/finbox/* routes exactly, because the
// proxy forwards the inbound path verbatim.
//
// UPLOAD_STATEMENT sits under /v2 because OTP-MS itself serves it from
// /api/v2/finbox, not /api/v1/finbox — the proxy mirrors the upstream's
// own version split.
export const FINBOX_ENDPOINTS = {
  CREATE_SESSION: "/v1/finbox/create-session",
  HISTORY: "/v1/finbox/history",
  UPLOAD_STATUS: "/v1/finbox/upload-status",
  ADD_OD_LIMIT: "/v1/finbox/add-od-limit",
  INITIATE_PROCESSING: "/v1/finbox/initiate-processing",
  RECALCULATE_SESSION: "/v1/finbox/recalculate-session",
  UPLOAD_STATEMENT: "/v2/finbox/upload-statement",
};
